module.exports = __webpack_public_path__ + "a102e5631626f71ddbc427003063dc0a.svg";